/* eslint-disable */
import React from "react";
import { ProfessionalBenefits } from "./partials";

class FullStackEngineer extends React.Component<{ path: string }> {
  render () {
    return (
      <div className="container page-container">
        <div className="card">
          <h2 style={{ marginBottom: 20, textAlign: "center" }}>
            Full-stack Web Developer - Denver, CO
          </h2>

          <h4>Responsibilities and Opportunities</h4>
          <p>
            You'll be tasked with building core application features, either designing the tables
            and APIs to drive it or the user interface to use it (or both). Your role here will be
            determined by your strengths and interests. You'll be given ample opportunity to become
            a domain expert and owner of the systems you are most interested in.
          </p>
          <p>
            Just as you'll be guiding the design and implementation of the product, you'll also be
            expected to help guide the direction of the software stack. Specifically, we're
            interested in migrating away from some technology choices which are no longer serving
            us, such as our roots in MeteorJS.
          </p>
          <p>
            You'll also have an opportunity to learn Elixir, a new functional programming language.
          </p>
          <br />

          <h4>Unique Technical Challenges and Opportunities</h4>
          <ul>
            <li>
              We're looking to bring great software practices to bear on an underrepresented market
            </li>
            <li>The product experience must be extremely empathetic to our users</li>
            <li>
              Since we operate in a heavily regulated space, our software must be thoroughly tested
              for compliance
            </li>
            <li>Data integrity is critical, and changes must be auditable</li>
          </ul>
          <br />

          <h4>Technical Requirements</h4>
          <ul>
            <li>Strong experience with TypeScript</li>
            <li>Strong experience with SQL</li>
            <li>Experience with React and single page applications</li>
            <li>Experience using relational databases, especially schema design</li>
            <li>Favors pragmatic functional programming</li>
          </ul>
          <br />

          <h4>Qualities We're Looking For</h4>
          <ul>
            <li>Marathon pace engineering ideals; thinking slow to move fast</li>
            <li>
              Comfortable working with both local and remote teams; you'll be working in an office
              in Denver and working with another team in Austin, TX.
            </li>
            <li>Comfortable providing and accepting feedback</li>
          </ul>
          <br />

          <h4>Our Stack</h4>
          <ul>
            <li>
              TypeScript single-page application using React, GraphQL (Apollo), and CSS modules
            </li>
            <li>Elixir server running on Phoenix and Absinthe for the GraphQL endpoint</li>
            <li>PostgreSQL database</li>
          </ul>

          <ProfessionalBenefits />
          <p style={{ fontSize: 15 }}>
            Please email resume to{" "}
            <a href="mailto:hiring@havenconnect.com">hiring@havenconnect.com</a>
          </p>
        </div>
      </div>
    );
  }
}

export default FullStackEngineer;
